import { SUPPORTED_EXTENSIONS } from '../constants';

export function showPicker() {
  return new Promise((resolve, reject) => {
    const extensions = SUPPORTED_EXTENSIONS.map(
      (mimeType) => `.${mimeType}`
    ).join(',');
    var odOptions = {
      clientId: 'ada08c7e-a01f-4d20-843b-df1be5874acd',
      action: 'download',
      multiSelect: false,
      advanced: { filter: extensions, redirectUri: window.location.origin },
      success: async function (files) {
        if (!files.value.length) return;
        const file = files.value[0];
        const url = file['@microsoft.graph.downloadUrl'];
        const name = file.name;
        const s = name.split('.');
        const fileType = s[s.length - 1];
        resolve({ name, url });
      },
      cancel: function () {
        //onUpload(false);
      },
      error: function (error) {
        reject(error);
      },
    };
    let OneDrive = window.OneDrive;
    try {
      OneDrive.open(odOptions);
    } catch (err) {}
  });
}
